module.exports = __webpack_public_path__ + "assets/img/icon-multi-location.ab7a5b2f.png";